import { render, staticRenderFns } from "./BaseMoreInfo.vue?vue&type=template&id=77dc5c92&scoped=true&"
import script from "./BaseMoreInfo.vue?vue&type=script&lang=ts&"
export * from "./BaseMoreInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc5c92",
  null
  
)

export default component.exports